import { render, staticRenderFns } from "./ImportProposalUploadPage.vue?vue&type=template&id=40576cc4"
import script from "./ImportProposalUploadPage.vue?vue&type=script&lang=js"
export * from "./ImportProposalUploadPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports